import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'

import SectionLink from './SectionLink'

const useStyles = makeStyles(sectionStyles)
 
export default function Sections ({sections, context}) {

  const classes = useStyles()

  const createSection = (section, index) => (<SectionLink {...{key: section.id, index, section, context, sections}} />)

  return (
    <Paper className={classes.root}>
      <Box className={classes.header}>
        <Box className={classes.label}>
          {context.translate('questions')}
        </Box>
      </Box>
      <Box className={classes.sections}>
        {sections.map(createSection)}
      </Box>
    </Paper>
  )  
}

function sectionStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      overflowY: 'hidden',
      display: 'flex',
      flexDirection: 'column'
    },
    header: {
      display: 'flex',
      padding: 10,
      color: '#555764',
      fontSize: '12pt'
    },
    label: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    sections: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
    }
  }
}
